import {
  LOAD_INITIAL_STATE,
  LOAD,
  LOAD_COMPLETE,
  REMOVE_SELECTED_ANTICIPATED_INVOICE,
  ANTICIPATED_INVOICE_SET,
  ANTICIPATED_INVOICE_RESET,
  AnticipatedInvoiceActions,
} from '../../actions/anticipated-invoice-actions/anticipated-invoice.actions';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { ISalesDocument } from '@cemex-core/cmx-api/models/sales-document-management/';

export interface IAnticipatedInvoiceState {
  required: boolean;
  disabled: boolean;
  loaded: boolean;
  visible: boolean;
  loading: boolean;
  salesDocuments: ISalesDocument[];
  selected: ISalesDocument;
}

export const initialState: IAnticipatedInvoiceState = {
  required: false,
  disabled: false,
  visible: false,
  loaded: false,
  loading: false,
  salesDocuments: [],
  selected: null,
};

export function anticipatedInvoiceReducer(
  state = initialState,
  action: AnticipatedInvoiceActions,
): IAnticipatedInvoiceState {
  switch (action.type) {
    case LOAD_INITIAL_STATE: {
      if (action.payload) {
        const antInvInitialState: ILocationConfigUnit = action.payload;
        return {
          ...state,
          disabled: antInvInitialState.disabled,
          required: antInvInitialState.required,
          visible: antInvInitialState.visible,
        } as IAnticipatedInvoiceState;
      } else {
        return {
          ...initialState,
        };
      }
    }
    case LOAD: {
      // case LOAD_COMPLETE: {
      return {
        ...state,
        loading: true,
      } as IAnticipatedInvoiceState;
    }
    case LOAD_COMPLETE: {
      const salesDocuments: ISalesDocument[] = action.payload.salesDocument;
      return {
        ...state,
        loaded: true,
        loading: false,
        salesDocuments: salesDocuments,
        disabled: false,
      } as IAnticipatedInvoiceState;
    }

    case REMOVE_SELECTED_ANTICIPATED_INVOICE: {
      return {
        ...state,
        selected: null,
      } as IAnticipatedInvoiceState;
    }

    case ANTICIPATED_INVOICE_SET: {
      const selectedSalesDocument: ISalesDocument = action.payload;
      return {
        ...state,
        selected: selectedSalesDocument,
      } as IAnticipatedInvoiceState;
    }
    case ANTICIPATED_INVOICE_RESET: {
      return {
        ...initialState,
      } as IAnticipatedInvoiceState;
    }
    default: {
      return state;
    }
  }
}
